module.exports = __webpack_public_path__ + "static/media/YOUNG_KID_COMPATIBLE.f60e9840.svg";